import { PagingResultsViewModel, EnumSiNoTodos, FilterSearchingBaseViewModel } from '../../../core/_infrastructure/types/common';

export class CertificadoSedeExportacionSLItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: CertificadoSedeExportacionSLItemViewModel[];
}

export class CertificadoSedeExportacionSLItemViewModel {
    public Id: number;
    public IdPuntoInspeccionEx: number;
    public IdTipoSolicitud: number;
    public IdEstadoSolicitud: number;
    public FechaEnvio: Date;
    public Codigo: string;
    public NumeroCertificado: string;
    public RefSolicitante: string;
    public NombreTipoSolicitud: string;
    public NombrePuntoInspeccion: string;
    public Firmado: boolean;
}

export class FilterSearchingCertificadoSedeExporSLViewModel extends FilterSearchingBaseViewModel {
    firstDayMonth: Date;
    lastDayMonth: Date;

    constructor() {
        super();

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        const temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        this.FechaDesde = this.firstDayMonth;
        this.FechaHasta = this.lastDayMonth;
    }
    public Codigo = '';
    public NumeroCertificado = '';
    public RefSolicitante = '';
    public IdPuntoInspeccion: number | null;
    public FechaDesde: Date | null;
    public FechaHasta: Date | null;
    public IdTipoSolicitudEx: number | null;
    public Firmado: number = EnumSiNoTodos.NO;
}
